import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "has-first-letter-uppercase has-text-success is-size-5" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "control" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    ref: "modal",
    onClosed: _ctx.onClosed
  }, {
    header: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1 /* TEXT */)
    ]),
    body: _withCtx(() => [
      _createElementVNode("form", {
        class: "my-3",
        onSubmit: _cache[1] || (_cache[1] = ($event: any) => ($event.preventDefault()))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_n_input, {
              value: _ctx.promptValue,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.promptValue) = $event)),
              type: "text"
            }, null, 8 /* PROPS */, ["value"])
          ])
        ])
      ], 32 /* HYDRATE_EVENTS */)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "button is-light mr-2",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close(false)))
      }, _toDisplayString(_ctx.$t('global.cancel')), 1 /* TEXT */),
      _createElementVNode("button", {
        type: "button",
        class: "button is-success",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
        disabled: !_ctx.promptValue
      }, _toDisplayString(_ctx.$t('global.ok')), 9 /* TEXT, PROPS */, _hoisted_4)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClosed"]))
}